export const observeViewportResize = (callback: () => void) => {
  let timeout: number | undefined;

  const onFrame = () => callback();

  const onResize = () => {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // don't fire the callback more often than once per each rendered frame
    timeout = window.requestAnimationFrame(onFrame);
  };

  window.addEventListener('resize', onResize, {
    passive: true,
  });

  const unsubscribe = () => {
    window.removeEventListener('resize', onResize);
  };

  return { unsubscribe };
};
